export enum EApiType {
  DEVELOP = 'dev',
  STAGING = 'staging',
  PRODUCTION = 'api',
}
